import { Link } from 'react-router-dom';

import { AppRoutes } from '@/utils/routes/router';

import { CookieSettingsLink } from './CookieConsent';

export default function LandingFooter() {
  return (
    <footer className="py-12 px-6 border-t border-light">
      <div className="max-w-6xl mx-auto text-center space-y-2">
        <p className="text-secondary">© 2026 ChurnSignal. Built for teams that care about retention.</p>
        <p className="text-sm text-muted">
          <Link to={AppRoutes.cookies} className="hover:text-primary">
            Cookies
          </Link>
          <span aria-hidden> · </span>
          <CookieSettingsLink className="hover:text-primary" />
          <span aria-hidden> · </span>
          Blackfield Labs doo · Novi Sad, Serbia
        </p>
      </div>
    </footer>
  );
}
